import { ITabs_Types } from 'types/interfaces';

export const VERIFIED_DAO_EXPERIENCE = 'verified_dao_experience';
export const FRIENDS_AND_ENEMIES = 'friends_and_enemies';

export const TABS_TYPES: ITabs_Types = {
    [VERIFIED_DAO_EXPERIENCE]: 'verified dao experience',
    [FRIENDS_AND_ENEMIES]: 'friends and enemies',
};
